@if (showCookieBar) {
    <div class="cookie-bar bg-white d-flex justify-content-center text-secondary shadow-lg w-100 position-fixed bottom-0">
        <div class="d-sm-flex cookie-content align-items-center">
            <div class="flex-grow-1 pt-5 px-5 p-sm-5">
                <span class="d-block h-100 fw-600 fs-16 font-secondary pb-3">{{ 'PAGE.COOKIES.title' | translate }}</span>
                <div class="h-100 fs-12 font-secondary">
                    {{ isBrowserEnableCookies ? ('PAGE.COOKIES.content' | translate) : ('PAGE.COOKIES.browser_blocked_cookies' | translate) }}
                    @if (isBrowserEnableCookies) {
                        <a class="font-secondary text-primary fs-14 fw-600" [routerLink]="['/legal', 'cookies-policy'] | localize"
                            >{{ 'PAGE.COOKIES.policy' | translate }}.</a
                        >
                    }
                </div>
            </div>
            <div class="lh-1 d-flex justify-content-end p-5">
                <app-button (btnClick)="hideCookieBar()" type="submit">
                    {{ isBrowserEnableCookies ? ('BUTTONS.understand' | translate) : ('BUTTONS.close' | translate) }}
                </app-button>
            </div>
        </div>
    </div>
}
